import { Button, ButtonProps, SxProps, Theme, Typography } from '@mui/material';
import LikeAnimation from '../LikeAnimation/LikeAnimation';
import { Advisor } from 'types';
import { useLikeAdviserProfilePlusByIdMutation } from 'services/api';
import { useContext, useMemo, useState } from 'react';
import ClientReplyFormModal from './ClientReplyFormModal';
import {
  FocusingAdviserProfile,
  FocusingAdviserProfileContext,
  trackMilestoneEvent,
} from 'hooks/hooks';

export default function LikeButton({
  className,
  sx,
  shouldShowLikeForm,
  ...props
}: {
  shouldShowLikeForm: boolean;
  className?: string;
  sx?: SxProps<Theme>;
  advisor?: Advisor;
} & ButtonProps) {
  const [likeAdviser] = useLikeAdviserProfilePlusByIdMutation();
  const [isShowClientReplyForm, setIsShowClientReplyForm] = useState(false);
  const FocusingAdviserProfile = useContext<FocusingAdviserProfile>(
    FocusingAdviserProfileContext,
  );
  const advisor = FocusingAdviserProfile.advisor;

  return useMemo(() => {
    const handleLikeAdvisor = async () => {
      if (advisor) {
        if (shouldShowLikeForm) {
          showLikeForm();
        }
        const res = await likeAdviser(advisor.adviserInfo._id);
        if (res && 'data' in res && res.data) {
          FocusingAdviserProfile.set.advisor(res.data);
          trackMilestoneEvent({
            type: 'Profile Like',
            event_properties: {
              Success: true,
              'Focusing Advisor ID': advisor.adviserInfo._id,
              'Focusing Advisor Email': advisor.adviserInfo.email,
              'Focusing Advisor Name': advisor.adviserInfo.name,
            },
          });
        }
      }
    };

    const showLikeForm = () => {
      setIsShowClientReplyForm(true);
    };

    const handleCloseLikeForm = () => {
      setIsShowClientReplyForm(false);
    };
    return (
      <LikeAnimation
        color="#ffffff"
        likes={FocusingAdviserProfile.advisor?.likes}
        render={anim => (
          <>
            <Button
              className={className}
              variant="contained"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                borderRadius: '100px',
                ...sx,
              }}
              {...props}
              disabled={!advisor}
              onClick={handleLikeAdvisor}
            >
              <Typography fontWeight={600}>Like</Typography>
              {anim}
              <Typography fontWeight={600}>
                {FocusingAdviserProfile.advisor?.likes}
              </Typography>
            </Button>
            <ClientReplyFormModal
              show={isShowClientReplyForm}
              onClose={handleCloseLikeForm}
            />
          </>
        )}
      />
    );
  }, [
    FocusingAdviserProfile.advisor?.likes,
    FocusingAdviserProfile.set,
    advisor,
    shouldShowLikeForm,
    likeAdviser,
    className,
    sx,
    props,
    isShowClientReplyForm,
  ]); // eslint-disable-line react-hooks/exhaustive-deps
}
